import { createSelector } from '@ngrx/store';
import { appSelector } from '../state/state.selector';

export const LoginDetailsSelector = createSelector(appSelector, (state) => state.login);
export const LoginTypeSelector = createSelector(LoginDetailsSelector, (state) => state.loginType);
export const LoginStatusSelector = createSelector(LoginDetailsSelector, (state) => state.loginStatus);

